export default "__VITE_ASSET__Ctcyjs$j__"